/**
 * Hook that provides a function to format numbers with K/M suffixes
 * Example: 1000 -> 1K, 1500 -> 1.5K, 1000000 -> 1M
 */
export function useFormatCount() {
  const formatCount = (count: number): string => {
    if (count >= 1000000) {
      return (count / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (count >= 1000) {
      return (count / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    return count.toString();
  };

  return { formatCount };
}